import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 4.529V18h-2.677V4.529zM13.58 7.407V18h-2.677V7.407zM9.22 2v16H6.545V2zM4.677 4.938V18H2V4.938z"
    }, null, -1)
  ])))
}
export default { render: render }